import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  modal: {
    fontFamily: theme.fontFamily,
    width: "440px",
    "& .modal-header": {
      padding: "24px 24px 20px",
      "& div": {
        height: "48px",
        width: "48px",
        border: "1px solid" + colors.lightGrey,
        borderRadius: "8px",
        padding: "12px",
        boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px",      
      lineHeight: "28px"
    },
    "& .modal-body": {
      padding: "8px 24px",
      fontSize: "14px",
      color: colors.mediumGrey,
      margin: "0px",
      lineHeight: "20px"
    },
    "& .modal-footer": {
      padding: "24px"
    },
    "& .modal-footer>*": {
      margin: "0px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  cancelBtn: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  }
}));

export default styles;
